import React from 'react';
import { clsx } from '../../utils';
import EzHeading from '../EzHeading';
import EzLayout from '../EzLayout';
import theme from '../theme.config';
var truncate = theme.css({
  '& div': {
    display: 'inline-block',
    maxWidth: '100%'
  },
  '& *': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});
var box = theme.css({
  position: 'relative'
});
var EzCardHeading = function EzCardHeading(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    actions = _ref.actions,
    titleIcon = _ref.titleIcon,
    truncateHeading = _ref.truncateHeading;
  var heading = title && React.createElement(EzLayout, {
    layout: "basic",
    alignY: "top"
  }, titleIcon, React.createElement(EzHeading, {
    size: "3",
    subheading: subtitle,
    truncateHeading: truncateHeading
  }, title));
  var layout = actions && React.createElement(EzLayout, {
    layout: "cluster",
    css: {
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }
  }, React.createElement("div", null, heading), React.createElement("div", null, actions));
  return React.createElement("div", {
    className: clsx(box(), truncateHeading && truncate())
  }, actions ? layout : heading);
};
EzCardHeading.displayName = 'EzCardHeading';
export default EzCardHeading;